import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
} from "react";

import { getUploadUrl } from "@repo/edtech-api";
import { ImageModalViewer, Radiodot } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import {
  QuestionComponentProps,
  useTestSolutionActionsContext,
  useTestSolutionValuesContext,
} from "../../../../../../../../model";
import { useTestInputVisibility } from '../../../../../../../../model/providers/test-solution-provider/useTestVisibility';
import { getConfig } from "../../../../../../../../origins";
import { CommentBlock } from '../comment-block/CommentBlock';

import st from "./ClosedOne.module.scss";

type Props = QuestionComponentProps;

export const ClosedOne: FC<Props> = ({
  answers,
  userAnswer,
  setUserAnswer,
  currentQuestion,
}) => {
  const { isImageWithModal } = getConfig();
  const userAnswerT = userAnswer as number;
  const setUserAnswerT = setUserAnswer as Dispatch<SetStateAction<number>>;
  const { userComment } = useTestSolutionValuesContext();
  const { setUserComment } = useTestSolutionActionsContext();
  const { setIsCommentRequiredAndEmpty } = useTestSolutionActionsContext();

  const onChange = (index: number) => {
    setUserAnswerT(index);
  };

  const isVisibleInput = useTestInputVisibility({
    answerInput: userAnswerT,
    currentQuestion,
  });

  useEffect(() => {
    const isCommentRequired = currentQuestion?.necessaryUserComment === 'checked';

    if (!isVisibleInput || !isCommentRequired) {
      setIsCommentRequiredAndEmpty(false);
      return;
    }

    setIsCommentRequiredAndEmpty(userComment.trim() === '');
  }, [
    isVisibleInput,
    userComment,
    setIsCommentRequiredAndEmpty,
    currentQuestion?.necessaryUserComment,
  ]);

  return (
    <div className={st.closed}>
      {
        currentQuestion?.questionImage && (
          <ImageModalViewer
            alt="closed-img"
            className={st.image}
            disabledModal={!isImageWithModal}
            src={getUploadUrl(currentQuestion.questionImage)}
          />
        )
      }
      <ul>
        {
          answers?.map((answer, index) => (
            <li
              key={index}
              className={st.li}
            >
              <Radiodot
                checked={userAnswerT === index}
                classNames={
                  clsx(st.answer,
                    userAnswerT === index && st.checked)
                }
                label={
                  (<div
                    className={
                      clsx(st.text,
                        userAnswerT === index && st.checked)
                    }
                  >
                    {answer}
                  </div>)
                }
                onChange={() => onChange(index)}
              />
            </li>
          ))
        }
      </ul>
      {
        isVisibleInput && (
          <CommentBlock
            comment={userComment}
            setComment={(event) => setUserComment(event.target.value)}
            title={currentQuestion?.userCommentPlaceholder}
          />
        )
      }
    </div>
  );
};
